
import { trackService } from "../../services/track.services";
import { mapMarkerService } from "../../services/map.marker.service";
import { staffService } from "../../services/staff.service";
import { clusterService } from "../../services/cluster.service";
import { STORE_CONSTANTS } from '../../common/store.constants';

const MARKER_TYPE_NAMES = {
    HOME_ADDRESSES: 'homeAddresses',
    CLUSTERS: 'clusters',
    STOP_POINTS: 'stopPoints',
    LAPTOP_GPS_POINTS: 'laptopGpsPoints',
    PHONE_GPS_POINTS: 'phoneGpsPoints',
    LAPTOP_CLOSEST_POINTS: 'laptopClosestPoint',
    PHONE_CLOSEST_POINTS: 'phoneClosestPoint',
    LAPTOP_TRAVEL_LINES: 'laptopTravel',
    PHONE_TRAVEL_LINES: 'phoneTravel',
    EROC_TASKS: 'EROCTasks',
    MROC_TASKS: 'MROCTasks',
    TASKS: 'tasks',
    VALIDS: 'valids',
    SUSPECTS: 'suspects',
};

const FIELDS = {
    DISPLAY: 'display',
    FEATURES: 'features',
    ARROWS: 'arrows'
}

const MUTATION_NAMES = STORE_CONSTANTS.VALIDATION.MUTATIONS.WITHOUT_NAMESPACE;
const ACTION_NAMES = STORE_CONSTANTS.VALIDATION.ACTIONS.WITHOUT_NAMESPACE;

const validation = {
    namespaced: true,
    actions: {
        setTaskFeatures(context, criteria ) {
            let features = [];

            criteria.features = features;
            context.dispatch('dailyTasks/setStaffDailyTasks', criteria);
        },
        clearMapData(context) {
            context.commit(ACTION_NAMES.CLEAR_MAP_DATA, {});
            context.commit(MUTATION_NAMES.CLEAR_POINT_INFO, {});
            context.commit(MUTATION_NAMES.CLEAR_TASK_TRACKS, {});
            context.dispatch('map/toggleRadiusDrawState', false, { root: true });
        },
        setPointInfo (context, study, pointId) {
            trackService.getTrack(study, pointId).then((resp) => {
                // success
                if (resp.data && resp.data.features) {
                    // get track data and pass to directive
                    // prepare popup data
                    const features = resp.data.features[0];
                    context.commit(MUTATION_NAMES.ADD_POINT_INFO, { id: pointId, value: features });
                } else {
                    console.log('No data found in tracking service for study: ' + study + ' and UUID of: ' + pointId);
                }
            })
            .catch((err) => {
                console.error('Error in tracking service: ' + err);
            });
        },
        setDayClusters (context, data) {
            // CLUSTERS: 'clusters',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.CLUSTERS, value: data.clusters });
            // STOP_POINTS: 'stopPoints',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.STOP_POINTS, value: data.stopPoints });
        },
        setDayGpsPoints (context, data) {
            // LAPTOP_GPS_POINTS: 'laptopGpsPoints',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.LAPTOP_GPS_POINTS, value: data.laptopGpsPoints });
            // PHONE_GPS_POINTS: 'phoneGpsPoints',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.PHONE_GPS_POINTS, value: data.phoneGpsPoints });
            // LAPTOP_CLOSEST_POINTS: 'laptopClosestPoint',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.LAPTOP_CLOSEST_POINTS, value: data.laptopClosestPoint });
            // PHONE_CLOSEST_POINTS: 'phoneClosestPoint',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.PHONE_CLOSEST_POINTS, value: data.phoneClosestPoint });
            // LAPTOP_TRAVEL_LINES: 'laptopTravel',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.LAPTOP_TRAVEL_LINES, value: data.laptopTravel });
            // PHONE_TRAVEL_LINES: 'phoneTravel',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.PHONE_TRAVEL_LINES, value: data.phoneTravel });
        },
        setDayTasks (context, data) {
            // HOME_ADDRESSES: 'homeAddresses',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, value: data.homeAddresses });
            // EROC_TASKS: 'EROCTasks',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.EROC_TASKS, value: data.erocTasks });
            // MROC_TASKS: 'MROCTasks',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.MROC_TASKS, value: data.mrocTasks });
            // TASKS: 'task',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.TASKS, value: data.tasks });
            // VALIDS: 'valid',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.VALIDS, value: data.valids });
            // SUSPECTS: 'suspect',
            context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.SUSPECTS, value: data.suspects });
        },
        // getEagleDay(context, criteria) {
        //     //criteria.startdate,criteria.enddate,criteria.staffId, criteria.study
        //     return new Promise((resolve, reject) => {
        //         clusterService.getEagleDay(criteria).then(async function (response) {
        //             if (response && response.data) {
        //                 let features = response.data.features;

        //                 // find alt addresses
        //                 let alt_address = mapMarkerService.getAlternateAddresses(features);
        //                 if (alt_address.length > 0) {
        //                     for (var i = 0; i < alt_address.length; i++) {
        //                         features.push(alt_address[i]);
        //                     }
        //                 }

        //                 context.commit(MUTATION_NAMES.SET_TASK_FEATURES, features);
        //                 context.dispatch(STORE_CONSTANTS.DAILY_TASKS.ACTIONS.WITH_NAMESPACE.SET_STAFF_DAILY_TASKS, { features: features, criteria: criteria }, { root: true });

        //                 const taskLayers = mapMarkerService.getAllTaskMarkers(features);
        //                 if(taskLayers.altAddr) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.altAddr });
        //                 }
        //                 if(taskLayers.tasks) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.tasks });
        //                 }
        //                 if(taskLayers.validTasks) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.validTasks });
        //                 }
        //                 if(taskLayers.suspectTasks) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.suspectTasks });
        //                 }
        //                 if(taskLayers.erocTasks) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.erocTasks });
        //                 }
        //                 if(taskLayers.mrocTasks) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.mrocTasks });
        //                 }
        //                 if(taskLayers.polys) {
        //                     context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: taskLayers.polys });
        //                 }

        //                 // criteria.staffId,criteria.study
        //                 staffService.getStaffHome(criteria).then(function (response) {
        //                     if (response && response.data) {
        //                         const homeLayers = mapMarkerService.getHomeMarkers(response.data.features);
        //                         console.log('setting home addresses in validation map store module: ', response.data);
        //                         context.commit(MUTATION_NAMES.SET_MAP_MARKERS_DATA, { id: MARKER_TYPE_NAMES.HOME_ADDRESSES, key: FIELDS.FEATURES, value: homeLayers });
        //                     }
        //                 });
        //             }
        //             resolve();
        //         })
        //         .catch(async function (e) {
        //             console.log(e);
        //             reject(e);
        //         })
        //         .finally(() => {
        //         });
        //     });
        // }
    },
    getters: {
        pointOfInterest: (state) => {
			return state.pointOfInterest;
		},
    },
    mutations: {
			clearPointInfo(state) {
				state.pointInfo = {};
			},
			addPointInfo(state, data ) {
				state.pointInfo[data.id] = data.value;
			},
			clearTaskTracks(state) {
				state.taskTracks = {};
			},
			addTaskTrack(state, data) {
				state.taskTracks[data.id] = data.value;
			},
			setMapMarkersData(state, data) {
					if(data.key) {
						state[data.id][data.key] = data.value;
					} else {
						state[data.id] = data.value;
					}
			},
			setTaskFeatures(state, features) {
				state.taskFeatures = features;
			},
			setIsValidationMapLoading(state, isLoading) {
				state.isLoading = isLoading;
			},
			setPointOfInterest (state, { data }) {
				state.pointOfInterest = data;
			},
			clearMapData(state, { data }) {
				console.log('Clearing map here...');
			}
	},
    state: {
        taskFeatures: null,
        pointInfo: {},
        taskTracks: {},
        isLoading: false,
        pointOfInterest: {},
    }
};

export default validation;
